import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'
import { LoginRequest } from '../../Types/General'
import { Client, ClientDashboardResponse, ComposeMessageTalent, bookmarkTalentRequest, clientRegistrationRequest } from '../../Types/Client'
import { AppSettings } from '../../Utils/Settings';
export const clientApi = createApi({
    reducerPath: 'clientApi',
    baseQuery: fetchBaseQuery({
        baseUrl: AppSettings.ApiBaseUrl,
        prepareHeaders: async (headers, {getState}) =>{
            if (!headers.has('Authorization')) {
                headers.set(
                    'Authorization',
                    `Bearer ${(localStorage.getItem('token') ?? '')}`
                );
            }
            return headers;
        }
    }),
    tagTypes: ['ClientData', 'ClientDashboard'],
    endpoints: (builder) => ({
        //TODO: Make getClients and getClient the same url with a parameter
        getClients: builder.query<Client[], void>({
            query: () => ({
                url: '/client/all',
                method: "GET"
            })
        }),
        getClient: builder.query<Client, string>({
            providesTags: ['ClientData'],
            query: (locator) => ({
                url: `/client/${locator}`,
                method: "GET"
            })
        }),
        registerClient: builder.mutation<any, {body: clientRegistrationRequest}>({
            query: (params) => ({
                url: '/client/register',
                method: "POST",
                body: params.body
            })
        }),
        loginClient: builder.mutation<any, LoginRequest>({
            query: (body) => ({
                url: '/client/login',
                method: "POST",
                body
            })
        }),
        updateClient: builder.mutation<any, any>({
            invalidatesTags:['ClientData', 'ClientDashboard'],
            query: (body) => ({
                url: `/client`,
                method: "PUT",
                body
            })
        }),
        deleteClient: builder.mutation<any, string>({
            query: (locator) => ({
                url: `/client/${locator}`,
                method: "DELETE"
            })
        }),
        uploadClientProfilePicture: builder.mutation<any, {locator: string, body: any}>({
            query: ({locator, body}) => ({
                url: `/client/${locator}/profile`,
                method: "POST",
                body
            })
        }),
        getClientProfilePicture: builder.query<string, string>({
            query: (locator) => ({
                url: `/client/profile-picture/${locator}`,
                method: "GET",
            })
        }),
        bookmarkTalent: builder.mutation<any, bookmarkTalentRequest>({
            invalidatesTags:['ClientData'],
            query: (body) => ({
                url: `/client/bookmark`,
                method: "PUT",
                body
            })
        }),
        unbookmarkTalent: builder.mutation<any, bookmarkTalentRequest>({
            invalidatesTags:['ClientData', 'ClientDashboard'],
            query: (body) => ({
                url: `/client/unbookmark`,
                method: "PUT",
                body
            })
        }),
        sendClientPasswordResetEmail: builder.mutation<any, {email: string}>({
            query: (body) => ({
                url: `/password-reset/client`,
                method: "POST",
                body
            })
        }),
        updateClientPassword: builder.mutation<any, {locator: string, password: string}>({
            query: ({locator, password}) => ({
                url: `/client/password/${locator}`,
                method: "POST",
                body: {password}
            })
        }),  
        deactivateClient: builder.mutation<any, string>({
            invalidatesTags: ['ClientData'],
            query: (locator) => ({
                url: `/client/deactivate/${locator}`,
                method: "POST",
            })
        }),  
        activateClient: builder.mutation<any, string>({
            invalidatesTags: ['ClientData'],
            query: (locator) => ({
                url: `/client/activate/${locator}`,
                method: "POST",
            })
        }),  
        getTalentsToMessage: builder.query<ComposeMessageTalent[], void>({
            query: () => ({
                url: `/client/compose`,
                method: "GET",
            })
        }),  
        getClientDashboard: builder.query<ClientDashboardResponse, void>({
            providesTags: ['ClientDashboard'],
            query: () => ({
                url: `/client/dashboard`,
                method: "GET",
            })
        })
    }),
})

export const {
    useGetClientsQuery,
    useGetClientQuery,
    useLazyGetClientQuery,
    useRegisterClientMutation,
    useLoginClientMutation,
    useUpdateClientMutation,
    useDeleteClientMutation,
    useUploadClientProfilePictureMutation,
    useBookmarkTalentMutation,
    useUnbookmarkTalentMutation,
    useSendClientPasswordResetEmailMutation,
    useGetClientProfilePictureQuery,
    useUpdateClientPasswordMutation,
    useDeactivateClientMutation,
    useActivateClientMutation,
    useGetTalentsToMessageQuery,
    useGetClientDashboardQuery
} = clientApi
